export { default as AcademicCap } from "./AcademicCap";
export { default as Adjustments } from "./Adjustments";
export { default as Annotation } from "./Annotation";
export { default as Archive } from "./Archive";
export { default as ArrowCircleDown } from "./ArrowCircleDown";
export { default as ArrowCircleLeft } from "./ArrowCircleLeft";
export { default as ArrowCircleRight } from "./ArrowCircleRight";
export { default as ArrowCircleUp } from "./ArrowCircleUp";
export { default as ArrowDown } from "./ArrowDown";
export { default as ArrowLeft } from "./ArrowLeft";
export { default as ArrowNarrowDown } from "./ArrowNarrowDown";
export { default as ArrowNarrowLeft } from "./ArrowNarrowLeft";
export { default as ArrowNarrowRight } from "./ArrowNarrowRight";
export { default as ArrowNarrowUp } from "./ArrowNarrowUp";
export { default as ArrowRight } from "./ArrowRight";
export { default as ArrowUp } from "./ArrowUp";
export { default as ArrowsExpand } from "./ArrowsExpand";
export { default as AtSymbol } from "./AtSymbol";
export { default as Backspace } from "./Backspace";
export { default as BadgeCheck } from "./BadgeCheck";
export { default as Ban } from "./Ban";
export { default as Beaker } from "./Beaker";
export { default as Bell } from "./Bell";
export { default as BookOpen } from "./BookOpen";
export { default as BookmarkAlt } from "./BookmarkAlt";
export { default as Bookmark } from "./Bookmark";
export { default as Briefcase } from "./Briefcase";
export { default as Cake } from "./Cake";
export { default as Calculator } from "./Calculator";
export { default as Calendar } from "./Calendar";
export { default as Camera } from "./Camera";
export { default as Cash } from "./Cash";
export { default as ChartBar } from "./ChartBar";
export { default as ChartPie } from "./ChartPie";
export { default as ChartSquareBar } from "./ChartSquareBar";
export { default as ChatAlt2 } from "./ChatAlt2";
export { default as ChatAlt } from "./ChatAlt";
export { default as Chat } from "./Chat";
export { default as CheckCircle } from "./CheckCircle";
export { default as Check } from "./Check";
export { default as ChevronDoubleDown } from "./ChevronDoubleDown";
export { default as ChevronDoubleLeft } from "./ChevronDoubleLeft";
export { default as ChevronDoubleRight } from "./ChevronDoubleRight";
export { default as ChevronDoubleUp } from "./ChevronDoubleUp";
export { default as ChevronDown } from "./ChevronDown";
export { default as ChevronLeft } from "./ChevronLeft";
export { default as ChevronRight } from "./ChevronRight";
export { default as ChevronUp } from "./ChevronUp";
export { default as Chip } from "./Chip";
export { default as ClipboardCheck } from "./ClipboardCheck";
export { default as ClipboardCopy } from "./ClipboardCopy";
export { default as ClipboardList } from "./ClipboardList";
export { default as Clipboard } from "./Clipboard";
export { default as Clock } from "./Clock";
export { default as CloudDownload } from "./CloudDownload";
export { default as CloudUpload } from "./CloudUpload";
export { default as Cloud } from "./Cloud";
export { default as Code } from "./Code";
export { default as Cog } from "./Cog";
export { default as Collection } from "./Collection";
export { default as ColorSwatch } from "./ColorSwatch";
export { default as CreditCard } from "./CreditCard";
export { default as CubeTransparent } from "./CubeTransparent";
export { default as Cube } from "./Cube";
export { default as CurrencyBangladeshi } from "./CurrencyBangladeshi";
export { default as CurrencyDollar } from "./CurrencyDollar";
export { default as CurrencyEuro } from "./CurrencyEuro";
export { default as CurrencyPound } from "./CurrencyPound";
export { default as CurrencyRupee } from "./CurrencyRupee";
export { default as CurrencyYen } from "./CurrencyYen";
export { default as CursorClick } from "./CursorClick";
export { default as Database } from "./Database";
export { default as DesktopComputer } from "./DesktopComputer";
export { default as DeviceMobile } from "./DeviceMobile";
export { default as DeviceTablet } from "./DeviceTablet";
export { default as DocumentAdd } from "./DocumentAdd";
export { default as DocumentDownload } from "./DocumentDownload";
export { default as DocumentDuplicate } from "./DocumentDuplicate";
export { default as DocumentRemove } from "./DocumentRemove";
export { default as DocumentReport } from "./DocumentReport";
export { default as DocumentSearch } from "./DocumentSearch";
export { default as DocumentText } from "./DocumentText";
export { default as Document } from "./Document";
export { default as DotsCircleHorizontal } from "./DotsCircleHorizontal";
export { default as DotsHorizontal } from "./DotsHorizontal";
export { default as DotsVertical } from "./DotsVertical";
export { default as Download } from "./Download";
export { default as Duplicate } from "./Duplicate";
export { default as EmojiHappy } from "./EmojiHappy";
export { default as EmojiSad } from "./EmojiSad";
export { default as ExclamationCircle } from "./ExclamationCircle";
export { default as Exclamation } from "./Exclamation";
export { default as ExternalLink } from "./ExternalLink";
export { default as EyeOff } from "./EyeOff";
export { default as Eye } from "./Eye";
export { default as FastForward } from "./FastForward";
export { default as Film } from "./Film";
export { default as Filter } from "./Filter";
export { default as FingerPrint } from "./FingerPrint";
export { default as Fire } from "./Fire";
export { default as Flag } from "./Flag";
export { default as FolderAdd } from "./FolderAdd";
export { default as FolderDownload } from "./FolderDownload";
export { default as FolderOpen } from "./FolderOpen";
export { default as FolderRemove } from "./FolderRemove";
export { default as Folder } from "./Folder";
export { default as Gift } from "./Gift";
export { default as GlobeAlt } from "./GlobeAlt";
export { default as Globe } from "./Globe";
export { default as Hand } from "./Hand";
export { default as Hashtag } from "./Hashtag";
export { default as Heart } from "./Heart";
export { default as Home } from "./Home";
export { default as Identification } from "./Identification";
export { default as InboxIn } from "./InboxIn";
export { default as Inbox } from "./Inbox";
export { default as InformationCircle } from "./InformationCircle";
export { default as Key } from "./Key";
export { default as Library } from "./Library";
export { default as LightBulb } from "./LightBulb";
export { default as LightningBolt } from "./LightningBolt";
export { default as Link } from "./Link";
export { default as LocationMarker } from "./LocationMarker";
export { default as LockClosed } from "./LockClosed";
export { default as LockOpen } from "./LockOpen";
export { default as Login } from "./Login";
export { default as Logout } from "./Logout";
export { default as MailOpen } from "./MailOpen";
export { default as Mail } from "./Mail";
export { default as Map } from "./Map";
export { default as MenuAlt1 } from "./MenuAlt1";
export { default as MenuAlt2 } from "./MenuAlt2";
export { default as MenuAlt3 } from "./MenuAlt3";
export { default as MenuAlt4 } from "./MenuAlt4";
export { default as Menu } from "./Menu";
export { default as Microphone } from "./Microphone";
export { default as MinusCircle } from "./MinusCircle";
export { default as MinusSm } from "./MinusSm";
export { default as Minus } from "./Minus";
export { default as Moon } from "./Moon";
export { default as MusicNote } from "./MusicNote";
export { default as Newspaper } from "./Newspaper";
export { default as OfficeBuilding } from "./OfficeBuilding";
export { default as PaperAirplane } from "./PaperAirplane";
export { default as PaperClip } from "./PaperClip";
export { default as Pause } from "./Pause";
export { default as PencilAlt } from "./PencilAlt";
export { default as Pencil } from "./Pencil";
export { default as PhoneIncoming } from "./PhoneIncoming";
export { default as PhoneMissedCall } from "./PhoneMissedCall";
export { default as PhoneOutgoing } from "./PhoneOutgoing";
export { default as Phone } from "./Phone";
export { default as Photograph } from "./Photograph";
export { default as Play } from "./Play";
export { default as PlusCircle } from "./PlusCircle";
export { default as PlusSm } from "./PlusSm";
export { default as Plus } from "./Plus";
export { default as PresentationChartBar } from "./PresentationChartBar";
export { default as PresentationChartLine } from "./PresentationChartLine";
export { default as Printer } from "./Printer";
export { default as Puzzle } from "./Puzzle";
export { default as Qrcode } from "./Qrcode";
export { default as QuestionMarkCircle } from "./QuestionMarkCircle";
export { default as ReceiptRefund } from "./ReceiptRefund";
export { default as ReceiptTax } from "./ReceiptTax";
export { default as Refresh } from "./Refresh";
export { default as Reply } from "./Reply";
export { default as Rewind } from "./Rewind";
export { default as Rss } from "./Rss";
export { default as SaveAs } from "./SaveAs";
export { default as Save } from "./Save";
export { default as Scale } from "./Scale";
export { default as Scissors } from "./Scissors";
export { default as SearchCircle } from "./SearchCircle";
export { default as Search } from "./Search";
export { default as Selector } from "./Selector";
export { default as Server } from "./Server";
export { default as Share } from "./Share";
export { default as ShieldCheck } from "./ShieldCheck";
export { default as ShieldExclamation } from "./ShieldExclamation";
export { default as ShoppingBag } from "./ShoppingBag";
export { default as ShoppingCart } from "./ShoppingCart";
export { default as SortAscending } from "./SortAscending";
export { default as SortDescending } from "./SortDescending";
export { default as Sparkles } from "./Sparkles";
export { default as Speakerphone } from "./Speakerphone";
export { default as Star } from "./Star";
export { default as StatusOffline } from "./StatusOffline";
export { default as StatusOnline } from "./StatusOnline";
export { default as Stop } from "./Stop";
export { default as Sun } from "./Sun";
export { default as Support } from "./Support";
export { default as SwitchHorizontal } from "./SwitchHorizontal";
export { default as SwitchVertical } from "./SwitchVertical";
export { default as Table } from "./Table";
export { default as Tag } from "./Tag";
export { default as Template } from "./Template";
export { default as Terminal } from "./Terminal";
export { default as ThumbDown } from "./ThumbDown";
export { default as ThumbUp } from "./ThumbUp";
export { default as Ticket } from "./Ticket";
export { default as Translate } from "./Translate";
export { default as Trash } from "./Trash";
export { default as TrendingDown } from "./TrendingDown";
export { default as TrendingUp } from "./TrendingUp";
export { default as Truck } from "./Truck";
export { default as Upload } from "./Upload";
export { default as UserAdd } from "./UserAdd";
export { default as UserCircle } from "./UserCircle";
export { default as UserGroup } from "./UserGroup";
export { default as UserRemove } from "./UserRemove";
export { default as User } from "./User";
export { default as Users } from "./Users";
export { default as Variable } from "./Variable";
export { default as VideoCamera } from "./VideoCamera";
export { default as ViewBoards } from "./ViewBoards";
export { default as ViewGridAdd } from "./ViewGridAdd";
export { default as ViewGrid } from "./ViewGrid";
export { default as ViewList } from "./ViewList";
export { default as VolumeOff } from "./VolumeOff";
export { default as VolumeUp } from "./VolumeUp";
export { default as Wifi } from "./Wifi";
export { default as XCircle } from "./XCircle";
export { default as X } from "./X";
export { default as ZoomIn } from "./ZoomIn";
export { default as ZoomOut } from "./ZoomOut";
